import { StudentsCourse, StudentsLesson } from "@feature/students";
import { Route, Routes } from "react-router-dom";
import clsx from "clsx";
import style from "@scss/pages/home.module.scss";

const Courses = () => {
  return (
    <main className="content-container">
      <div className="content-section">
        <div className={clsx(style.home_content)}>
          <div className={clsx(style.top_blocks)}>
            <div className={clsx(style.calendar_block, "bg-white")}>
              <Routes>
                <Route path="/:courseId" Component={StudentsCourse} />
                <Route path="/:courseId/lesson/:lessonId" Component={StudentsLesson} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Courses;
